/**
 * ACF Google Map JS code
 * @param $
 */

(function ($) {
	/*
	 *  This function will render a Google Map onto the selected jQuery element
	 */
	function render_map($el) {
		// var
		const $markers = $el.find('.js-map-marker');
		const styles = [
			{
				featureType: 'water',
				elementType: 'geometry',
				stylers: [
					{
						color: '#e9e9e9',
					},
					{
						lightness: 17,
					},
				],
			},
			{
				featureType: 'landscape',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
					{
						lightness: 20,
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 17,
					},
				],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 29,
					},
					{
						weight: 0.2,
					},
				],
			},
			{
				featureType: 'road.arterial',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 18,
					},
				],
			},
			{
				featureType: 'road.local',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				featureType: 'poi',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f5f5f5',
					},
					{
						lightness: 21,
					},
				],
			},
			{
				featureType: 'poi.park',
				elementType: 'geometry',
				stylers: [
					{
						color: '#dedede',
					},
					{
						lightness: 21,
					},
				],
			},
			{
				elementType: 'labels.text.stroke',
				stylers: [
					{
						visibility: 'on',
					},
					{
						color: '#ffffff',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				elementType: 'labels.text.fill',
				stylers: [
					{
						saturation: 36,
					},
					{
						color: '#333333',
					},
					{
						lightness: 40,
					},
				],
			},
			{
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off',
					},
				],
			},
			{
				featureType: 'transit',
				elementType: 'geometry',
				stylers: [
					{
						color: '#f2f2f2',
					},
					{
						lightness: 19,
					},
				],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#fefefe',
					},
					{
						lightness: 20,
					},
				],
			},
			{
				featureType: 'administrative',
				elementType: 'geometry.stroke',
				stylers: [
					{
						color: '#fefefe',
					},
					{
						lightness: 17,
					},
					{
						weight: 1.2,
					},
				],
			},
		];
		const zoom = $markers.data('zoom')
			? parseInt($markers.data('zoom'))
			: 14;
		// vars
		const args = {
			zoom,
			center: new google.maps.LatLng(0, 0),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			styles, // Uncomment for map styling
		};

		// create map
		const map = new google.maps.Map($el[0], args);

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each(function () {
			add_marker($(this), map);
		});

		// center map
		center_map(map);
	}

	/*
	 *  This function will add a marker to the selected Google Map
	 */
	let infowindow;

	function add_marker($marker, map) {
		// var
		const latlng = new google.maps.LatLng(
			$marker.attr('data-lat'),
			$marker.attr('data-lng')
		);

		// create marker
		const marker = new google.maps.Marker({
			position: latlng,
			map,
			optimized: false,
			animation: google.maps.Animation.DROP,
			icon: {
				url: $marker.data('marker-icon'),
				scaledSize: new google.maps.Size(126, 84),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(23, 84), // Adjust anchor point based on the icon size
				labelOrigin: new google.maps.Point(63, 20), // Adjust labelOrigin for proper positioning
			},
		});

		// add to array
		map.markers.push(marker);

		// if marker contains HTML, add it to an infoWindow
		if ($.trim($marker.html())) {
			// create info window
			infowindow = new google.maps.InfoWindow();

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', function () {
				// Close previously opened infowindow, fill with new content and open it
				infowindow.close();
				infowindow.setContent($marker.html());
				infowindow.open(map, marker);
			});
		}
	}

	/*
	 *  This function will center the map, showing all markers attached to this map
	 */
	function center_map(map) {
		// vars
		const bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each(map.markers, function (i, marker) {
			const latlng = new google.maps.LatLng(
				marker.position.lat(),
				marker.position.lng()
			);

			bounds.extend(latlng);
		});

		// only 1 marker?
		if (map.markers.length == 1) {
			// set center of map
			map.setCenter(bounds.getCenter());
		} else {
			// fit to bounds
			map.fitBounds(bounds);
		}
	}

	/*
	 *  This function will render each map when the document is ready (page has loaded)
	 */
	$('.js-map-google').each(function () {
		render_map($(this));
	});
})(jQuery);
